import { render, staticRenderFns } from "./ShoppingCartList.vue?vue&type=template&id=42595d71&"
import script from "./ShoppingCartList.vue?vue&type=script&lang=js&"
export * from "./ShoppingCartList.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingCartList.vue?vue&type=style&index=0&id=42595d71&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports